/** Load gtag when a measurement ID is configured. */
export function initGtag(): void {
  const id = import.meta.env.VITE_GOOGLE_ANALYTICS_TRACKING_ID;
  if (!id) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", id);

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  document.head.appendChild(script);
}
